export default "__VITE_ASSET__CDE32xcc__"